// src/app/pages/PaymentPage/controller/PaymentPageController.ts
export class PaymentPageController {
  formatAmount(amount: number): string {
    return `${amount} ₽`;
  }
}